window.twoFactorAuthenticationProfileApp = function (data = {}) {
    return {
        enabled: data.enabled || false,
        showingQrCode: false,
        twoFactorQrCodeSvg: null,
        showingRecoveryCodes: false,
        twoFactorRecoveryCodes: [],
        async enable() {
            await axios.post('/auth/user/two-factor-authentication');
            await this.showQrCode();
            await this.showRecoveryCodes();
            this.enabled = true;
        },
        disable() {
            return axios.delete('/auth/user/two-factor-authentication').then((res) => {
                this.enabled = false;
                this.showingQrCode = false;
                this.showingRecoveryCodes = false;
            });
        },
        showQrCode() {
            return axios.get('/auth/user/two-factor-qr-code').then((res) => {
                this.showingQrCode = true;
                this.twoFactorQrCodeSvg = res.data.svg;
            });
        },
        showRecoveryCodes() {
            return axios.get('/auth/user/two-factor-recovery-codes').then((res) => {
                this.showingRecoveryCodes = true;
                this.twoFactorRecoveryCodes = res.data;
            });
        },
        regenerateRecoveryCodes() {
            return axios.post('/auth/user/two-factor-recovery-codes').then((res) => {
                this.showRecoveryCodes();
            });
        },
    };
};
